module.exports = __webpack_public_path__ + "static/media/clock.a4e31d85.svg";